export default {
  ID: 'id',
  // 0
  // CREATE_DATE_PROPERTY_NAME: 'createDatePropertyName', // "string",
  // LAST_MODIFIED_PROPERTY_NAME: 'lastModifiedPropertyName', // "string",
  // PIPELINE_PROPERTY_NAME: 'pipelinePropertyName', // "string",
  // PIPELINE_STAGE_PROPERTY_NAME: 'pipelineStagePropertyName', // "string",
  // export const PIPELINE_CLOSE_DATE_PROPERTY_NAME =
  //   'pipelineCloseDatePropertyName'; // "string",
  // export const PIPELINE_TIME_TO_CLOSE_PROPERTY_NAME =
  //   'pipelineTimeToClosePropertyName'; // "string",
  PRIMARY_DISPLAY_LABEL: 'primaryDisplayLabelPropertyName',
  SECONDARY_DISPLAY_LABELS: 'secondaryDisplayLabelPropertyNames',
  NAME: 'name',
  // "string",
  META_TYPE: 'metaType',
  // "HUBSPOT",
  META_TYPE_ID: 'metaTypeId',
  // 0,
  // HAS_CUSTOM_PROPERTIES: 'hasCustomProperties', // true,
  // HAS_DEFAULT_PROPERTIES: 'hasDefaultProperties', // true,
  // HAS_PUBLIC_API: 'hasPublicApi', // true,
  // HAS_PIPELINES: 'hasPipelines', // true,
  // HAS_OWNERS: 'hasOwners', // true,
  // IS_ASSET: 'isAsset', // true,
  // HAS_EXTERNAL_OBJECT_IDS: 'hasExternalObjectIds', // true,
  // RESTORABLE: 'restorable', // true,
  // INDEXED_FOR_FILTERS_AND_REPORTS: 'indexedForFiltersAndReports', // true,
  DEFAULT_SEARCH_PROPERTY_NAMES: 'defaultSearchPropertyNames',
  // ["string"],
  REQUIRED_PROPERTIES: 'requiredProperties',
  // ["string"],
  // OBJECT_SUMMARY_PROPERTY_NAMES: 'objectSummaryPropertyNames', // ["string"],
  // INTEGRATION_APP_ID: 'integrationAppId', // 0,
  // OWNER_PORTAL_ID: 'ownerPortalId', // 0,
  SINGULAR_FORM: 'singularForm',
  // "string",
  PLURAL_FORM: 'pluralForm',
  // "string",
  // READ_SCOPE_NAME: 'readScopeName', // "string",
  // WRITE_SCOPE_NAME: 'writeScopeName', // "string",
  // ACCESS_SCOPE_NAME: 'accessScopeName', // "string",
  // JANUS_GROUP: 'janusGroup', // "string",
  // PERMISSIONING_TYPE: 'permissioningType', // "string",
  // SCOPE_MAPPINGS: 'scopeMappings', // [{"requestAction": "string","accessLevel": "string","scopeName": "string"}],
  FULLY_QUALIFIED_NAME: 'fullyQualifiedName' // "string"
};